// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { FileTypeSchema } from '../inputTypeSchemas/FileTypeSchema'

/////////////////////////////////////////
// APPLICATION FILE SCHEMA
/////////////////////////////////////////

export const ApplicationFileSchema = z.object({
  type: FileTypeSchema,
  id: z.string(),
  tenantId: z.string().nullable(),
  s3Bucket: z.string().nullable(),
  s3Key: z.string().nullable(),
  s3Etag: z.string().nullable(),
  s3Location: z.string().nullable(),
  content: z.string().nullable(),
  name: z.string(),
  size: z.number().int(),
  mimeType: z.string().nullable(),
  encoding: z.string().nullable(),
  applicationId: z.string().nullable(),
  createdAt: z.coerce.date().nullable(),
  updatedAt: z.coerce.date().nullable(),
})

export type ApplicationFile = z.infer<typeof ApplicationFileSchema>

export default ApplicationFileSchema;
